import {ENDPOINT_URL} from '../constants/index';
import {apiErrorHandling} from '../utils/apiUtils';

import getFetchOptions from '../utils/getFetchOptions';

export default function deleteTestAdmin(testAdminId) {
	return fetch(
		`${ENDPOINT_URL}/adminuser/${testAdminId}`,
		getFetchOptions({
			method: 'DELETE',
		})
	)
		.then((response) => {
			if (!response.ok) {
				throw response;
			}
			return response.json();
		})
		.catch((err) => {
			return Promise.reject(apiErrorHandling(err));
		});
}
